import React from "react";
import { Button } from "../ui/button";
import { Send } from "lucide-react";
import { cn } from "../../lib/utils";

/**
 * ChatInput Component
 * Input field with send button for chat messages
 */
const ChatInput = ({
  value,
  onChange,
  onSend,
  onKeyPress,
  placeholder = "Ask me about Koflip...",
  disabled = false,
  isTyping = false,
  isAvailable = true,
  isMobile = false,
  inputRef,
}) => {
  return (
    <div className="p-2 sm:p-3 bg-background border-t flex items-end gap-2 sm:gap-3">
      <textarea
        ref={inputRef}
        value={value}
        onChange={onChange}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        disabled={disabled || isTyping || !isAvailable}
        rows={1}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="true"
        data-form-type="other"
        data-lpignore="true"
        className={cn(
          "flex-1 border border-input rounded-2xl sm:rounded-3xl p-3 sm:p-4 resize-none font-inherit text-[0.85rem] sm:text-sm min-h-[18px] sm:min-h-[20px] max-h-[60px] sm:max-h-[80px] outline-none bg-background text-foreground transition-all",
          isAvailable
            ? "focus:border-primary focus:ring-2 focus:ring-primary/20"
            : "opacity-50 cursor-not-allowed",
          isTyping && "opacity-50"
        )}
        style={{
          fontSize: isMobile ? "16px" : undefined,
          WebkitAppearance: "none",
        }}
      />
      <Button
        onClick={onSend}
        disabled={!value.trim() || isTyping || !isAvailable || disabled}
        size="icon"
        className="bg-gradient-to-br from-primary to-orange-600 text-white w-[42px] h-[42px] sm:w-10 sm:h-10 min-w-0 hover:shadow-lg disabled:from-muted disabled:to-muted disabled:text-muted-foreground active:scale-95 transition-all rounded-full"
      >
        <Send className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default ChatInput;
